import { Controller } from "@hotwired/stimulus"

// AT-1113: opnieuw ophalen na een terugknop van de browser.
//
// Terug haalt een pagina uit de bfcache: hij komt terug precies zoals hij was, uit het
// geheugen, zonder dat de server er iets van merkt. Op de meeste schermen is dat prettig
// -- het is meteen en je scrollpositie klopt nog. Op de ticketstap is het gevaarlijk,
// want alles wat daar staat gaat over iemands bestelling en die is intussen veranderd.
//
// Gemeten: mandje met 3 kaarten, terug met de browser, en dan staat er "2 tickets" in de
// kop en 2 in het veld dat de server destijds invulde. Klik je vanaf zo'n pagina op
// verder, dan leg je jezelf vast op het aantal dat je toevallig te zien kreeg.
//
// Bewust alleen hier. Op het gegevensscherm zou herladen wissen wat de bezoeker net heeft
// ingetypt, en dat is een grotere schade dan een verouderd getal.
//
// persisted onderscheidt een herstel uit de cache van een gewone lading; bij een gewone
// lading is er niets te verversen, en die staat garandeert ook dat het herladen zelf geen
// nieuwe ronde start.
export default class extends Controller {
  connect() {
    this.opnieuw = (event) => { if (event.persisted) window.location.reload() }
    window.addEventListener("pageshow", this.opnieuw)
  }

  disconnect() {
    window.removeEventListener("pageshow", this.opnieuw)
  }
}
